import {buttonEnum} from '../helper'

class MenuButtonParent extends THREE.Object3D {
    static instance;

    constructor() {
        super();
        if (!MenuButtonParent.instance) {
            MenuButtonParent.instance = this;
            this.setupInstance();
        }

        return MenuButtonParent.instance;
    }

    setupInstance() {
        this.position.copy(iq3Camera.camera.position);
        this.position.copy(iq3Camera.camera.quaternion);

        if (cameraTracker) {
            cameraTracker.add(this);
        } else {
            console.error('CameraTracker not found');
        }
        
    }

    rotateInstance(yAxisForRotation, leftRightRotationDelta) {
        const rotationCenter = iq3Camera.camera.position;
        const applyMatrix = getRotationTranslationMatrix(rotationCenter, yAxisForRotation, leftRightRotationDelta, MenuButtonParent.instance);
        MenuButtonParent.instance.applyMatrix4(applyMatrix);
        buttonController.getButtonByName(buttonEnum.MENU)?.setDeltaAndYAxisOfRotation(yAxisForRotation, leftRightRotationDelta);
        buttonController.getButtonByName(buttonEnum.MENU_TOGGLE)?.setDeltaAndYAxisOfRotation(yAxisForRotation, leftRightRotationDelta);
    }

    resetRotation() {
        const toggleButton = buttonController.getButtonByName(buttonEnum.MENU_TOGGLE);
        const deltaAndYAxis = toggleButton?.getDeltaAndYAxisOfRotation();

        if(!deltaAndYAxis || !deltaAndYAxis.delta || !deltaAndYAxis.yAxisForRotation) {
            return;
        }

        this.rotateInstance(deltaAndYAxis.yAxisForRotation, -deltaAndYAxis.delta);
        toggleButton.rotateMenuAttachedWithCameraTracker(deltaAndYAxis.yAxisForRotation, -deltaAndYAxis.delta);
    }

    static getInstance() {
        if (MenuButtonParent.instance) {
            return MenuButtonParent.instance;
        }

        return new MenuButtonParent();
    }
}

export default MenuButtonParent;
